import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { proxySSODispatchers as stateProps } from '../../redux/modules/app/dispatchers'

function ProxySSO(props) {
  const location = useLocation()

  useEffect(() => {
    const query = Object.fromEntries(new URLSearchParams(location.search))
    props.proxyLoginSSODispatcher({ ...props, location: { ...location, query } })
  }, [])

  return <div id="ProxySSO" />
}

export default connect(null, stateProps)(ProxySSO)
